import { Component, OnInit } from '@angular/core';
import { MasterService } from '../master.service';

@Component({
  selector: 'app-deleteactication',
  templateUrl: './deleteactication.component.html',
  styleUrls: ['./deleteactication.component.scss']
})
export class DeleteacticationComponent implements OnInit {
  ProductList = [];
  productarryalist = [];
  ischeck = false;
  schoolname;
  mobileno;
  serialno;

  constructor(private service: MasterService) { }

  ngOnInit() { }

  FilterRecord(schoolname, mobileno, serialno) {
    this.productarryalist = [];
    this.ProductList = [];

    const school = schoolname || '';
    const mobile = mobileno || '';
    const serial = serialno || '';

    if (!school && !mobile && !serial) {
      alert("Fill at least one field");
      return;
    }

    this.service.GetProductNotActivatedListToRemove(
      (school), (mobile), (serial)
    ).subscribe((data: any) => {
      this.ProductList = data;
      this.ProductList.forEach(item => {
        item.actkey = false; // default unselected
      });
    });
  }

  SelectAll(ischeck) {
    this.ischeck = ischeck;
    this.productarryalist = [];

    this.ProductList.forEach(obj => {
      obj.actkey = ischeck;
      if (ischeck) {
        this.productarryalist.push(obj.userid);
      }
    });
  }

  CheckboxSelect(chk: boolean, data: any) {
    if (chk) {
      if (!this.productarryalist.includes(data.userid)) {
        this.productarryalist.push(data.userid);
      }
    } else {
      const index = this.productarryalist.indexOf(data.userid);
      if (index !== -1) {
        this.productarryalist.splice(index, 1);
      }
    }
  }

  Delete() {
    if (this.productarryalist.length === 0) {
      alert("Please select at least one record to delete.");
      return;
    }

    const confirmed = confirm("Are you sure you want to delete the selected activation(s)?");
    if (!confirmed) return;

    this.service.DeleteOldActivation(this.productarryalist).subscribe((res: any) => {
      if (res === "Success") {
        alert("Selected activations deleted successfully.");

        // Remove only the selected userids from ProductList
        this.ProductList = this.ProductList.filter(item =>
          !this.productarryalist.includes(item.userid)
        );

        // Clear selection
        this.productarryalist = [];
        this.ischeck = false;
      } else {
        alert("Failed to delete activations.");
      }
    });
  }
}
